import React, { useState, useCallback, useRef } from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { blogsSlidesData, blogHeading } from "../../data/blogsData";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, Autoplay } from "swiper/modules";
import Button from "../CtaButton";

const TrendsInsights = ({ specificClass, category, heading, description, customClass }) => {
  // const filteredBlogs = category === "all"
  //   ? blogsSlidesData
  //   : blogsSlidesData.filter((blog) => blog.category === category);

  const { t } = useTranslation("blogs"); // ✅ Set correct namespace

  const blogsSlides = t("blogsSlideData", { returnObjects: true });
  const blogsHeadings = t("blogsHeadings", { returnObjects: true });

  const filteredBlogs =
    category.toLowerCase() === "all"
      ? blogsSlides
      : blogsSlides.filter((blog) => blog.category === category);

  // SLIDER ARROWS
  const sliderRef = useRef();
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsBeginning(swiper.isBeginning);
    setIsEnd(swiper.isEnd);
  };
  // SLIDER ARROWS

  return (
    <div
      className={`trends-insights space-top-padding ${specificClass}`}
      id="trends"
    >
      <div className="container">
        <div className="row">
          <div className={`col-xl-8 col-lg-8 col-md-8 col-sm-7 col-12 blog-section-bottom-margin ${customClass}`}>
            <h2 className="blog-main-heading">
              {heading ? heading : blogsHeadings?.heading}
            </h2>
            <h3 className="sub-heading text-left">
              {description ? description : blogsHeadings?.subHeading}
            </h3>
          </div>

          <div className="col-xl-4 col-xl-4 col-md-4 col-sm-5 trend-insight-bottom-cta col-12">
            <div className="d-flex justify-content-end none-mobile-btn">
              {/* <Link
                className="consult-project-scope"
                to={`/blogs?category=${encodeURIComponent(category)}`}
              >
                {blogsHeadings?.buttonText}
              </Link> */}

              <Button
                text={blogsHeadings?.buttonText}
                link={`/blogs?category=${encodeURIComponent(category)}`}
              />
            </div>

            <div className={`arrow-developing-slider mt-4`}>
              <img
                onClick={handlePrev}
                src="/images/arrow-right.png"
                className={`left-image ${isBeginning ? "disabled" : ""}`}
                alt="Arrow"
                style={{ cursor: isBeginning ? "not-allowed" : "pointer" }}
              />
              <img
                onClick={handleNext}
                src="/images/arrow-right.png"
                className={`right-arrow-image ${isEnd ? "disabled" : ""}`}
                alt="Arrow"
                style={{ cursor: isEnd ? "not-allowed" : "pointer" }}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            {filteredBlogs?.length > 0 ? (
              <>
                <Swiper
                  slidesPerView={4}
                  spaceBetween={20}
                  onSlideChange={handleSlideChange}
                  autoplay={{
                    delay: 5000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                  }}
                  navigation={false}
                  modules={[Navigation, Autoplay]}
                  className="mySwiper"
                  ref={sliderRef}
                  breakpoints={{
                    425: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    375: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    320: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                    768: {
                      slidesPerView: 2,
                      spaceBetween: 10,
                    },
                    1280: {
                      slidesPerView: 4,
                      spaceBetween: 30,
                    },
                  }}
                >
                  {filteredBlogs?.map((item, index) => {
                    return (
                      <SwiperSlide key={index}>
                        <Link
                          to={`/blogs/${item?.slug
                            .toLowerCase()
                            .replace(
                              /[^\u0600-\u06FF\u0750-\u077F\u08A0-\u08FFa-z0-9\s-]/g,
                              ""
                            )
                            .trim()
                            .replace(/\s+/g, "-")}`}
                          key={index}
                        >
                          <div className="blog-card-main-box">
                            <div className="blog-card-image">
                              <img src={item?.imageSrc} alt="" />
                            </div>

                            <div className="blog-card-text">
                              <div className="blog-card-category">
                                <p>{item?.category?.replace(/-/g, " ")}</p>
                                <h2 className="blog-card-heading-text">
                                  {item?.title}
                                </h2>
                                {/* <Link to="/" className="blog-text-button">
                                  {blogsHeadings?.seeDetails}
                                </Link> */}
                              </div>
                            </div>
                          </div>
                        </Link>
                      </SwiperSlide>
                    );
                  })}
                </Swiper>
              </>
            ) : (
              <p>No blogs available for this category.</p>
            )}
          </div>

          {/* <div className="col-md-12">
            <div className="new-blog-button">
              <Button
                text={blogsHeadings?.buttonText}
                link={`/blogs?category=${encodeURIComponent(category)}`}
              />
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default TrendsInsights;
